export function isWeCom() {
  return /wxwork/i.test(navigator.userAgent) || /MicroMessenger/i.test(navigator.userAgent);
}
const corpId = import.meta.env.VITE_WECOM_CORPID;
const agentId = import.meta.env.VITE_WECOM_AGENTID;
// 企业微信弹窗授权 URL（snsapi_userinfo）
export function buildWeComUserinfoAuthUrl({ redirectUrl, state = 'STATE123' }) {
  return (
    "https://open.weixin.qq.com/connect/oauth2/authorize" +
    `?appid=${corpId}` +
    `&redirect_uri=${encodeURIComponent(redirectUrl)}` +
    "&response_type=code" +
    "&scope=snsapi_privateinfo" +      // 🔥 弹窗授权必须写这个
    `&agentid=${agentId}` +
    `&state=${state}#wechat_redirect`
  );
}
